<template>
  <van-overlay
    :show="showPopup && slides.length > 0"
    @click="showPopup = false"
  >
    <div
      class="wrapper col-lg-4 col-md-12 mx-auto d-flex h-100vh"
      @click.stop
    >
      <div
        class="mx-auto my-auto pt-4 px-4 pb-4 welcome-popup"
      >
        <b-carousel
          v-if="slides.length"
          id="welcome-images-carousel"
          :key="slides.map((item) => item.image).join('|')"
          :interval="3000"
          controls
          fade
          style="width: 100%; height: 100%"
        >
          <b-carousel-slide
            v-for="(item, index) in slides"
            :key="`${item.id}-${index}`"
            :img-src="item.image"
          ></b-carousel-slide>
        </b-carousel>

        <div class="mt-3 d-flex flex-column">
          <div class="mx-auto mb-3">
            <div class="d-flex">
              <input
                type="checkbox"
                v-model="isHideForToday"
                class="mb-1 mr-2 p-0 m-0"
              />
              <h3 class="text-white text-center p-0 m-0">Hide For Today</h3>
            </div>
          </div>

          <button
            class="btn btn-primary btn-block w-25 mx-auto text-uppercase"
            style="background: radial-gradient(circle at 10% 20%, rgb(241, 121, 226) 0%, #DD4DD1 86.8%) !important;"
            @click="closePopup()"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
const MOCK_WELCOME_IMAGES = [
  {
    id: 'mock-welcome-1',
    image: 'https://storage.googleapis.com/spacetech2/melonzeed/melonzeed-welcom.webp',
  },
  {
    id: 'mock-welcome-2',
    image: 'https://storage.googleapis.com/spacetech2/melonzeed/welcome.webp',
  },
];

export default {
  data() {
    return {
      isHideForToday: false,
      showPopup: false,
      slides: [],
    };
  },
  async mounted() {
    await this.fetchWelcomeImages();
    this.checkPopupStatus();
  },
  methods: {
    closePopup() {
      this.showPopup = false;
      if (!this.isHideForToday) {
        return;
      }
      const today = new Date().toISOString().split('T')[0];
      localStorage.setItem('popupDismissedDate', today);
    },
    checkPopupStatus() {
      const today = new Date().toISOString().split('T')[0];
      const lastDismissedDate = localStorage.getItem('popupDismissedDate');
      this.showPopup = lastDismissedDate !== today && this.slides.length > 0;
    },
    async fetchWelcomeImages() {
      try {
        const res = await axios.get('/welcome-images');
        const slides = this.normalizeImages(res.data);
        this.slides = slides.length ? slides : MOCK_WELCOME_IMAGES;
      } catch (error) {
        this.slides = MOCK_WELCOME_IMAGES;
      }
    },
    normalizeImages(payload) {
      const raw = Array.isArray(payload)
        ? payload
        : (Array.isArray(payload?.data) ? payload.data : []);

      return raw
        .map((item, index) => ({
          id: item?.id ?? `welcome-${index}`,
          image: ([
            item?.image,
            item?.imageUrl,
            item?.image_url,
            item?.thumbnail,
            item?.url,
          ].find((value) => typeof value === 'string' && value.trim()) || '').trim(),
        }))
        .filter((item) => item.image);
    },
  },
};
</script>

<style scoped>
.welcome-popup {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 7px;
  max-height: 90vh;
  overflow-y: auto;
  width: min(100%, 420px);
}

.welcome-popup ::v-deep .carousel-item img,
.welcome-popup ::v-deep img {
  width: 100%;
  max-height: 68vh;
  object-fit: contain;
}

.van-overlay {
  background: rgba(0, 0, 0, 0.4) !important;
}
</style>
